const routes =  [

  //deliveries routes
    { 
      path: "deliveries", 
      name: "deliveries",
      component: function () {
        return import( '@/accounting/deliveries/index.vue')
      }
    },
    {
      path: "deliveries/create",
      name: "deliveriesCreate",
      component: function () {
        return import( '@/accounting/deliveries/form.vue')
      }
    },
    {
      path: "deliveries/:id/edit",
      name: "deliveriesEdit",
      component: function () {
        return import( '@/accounting/deliveries/form.vue')
      }
    },

      //cities routes
    {
      path: "cities",
      name: "cities",
      component: function () {
        return import( '@/accounting/cities/index.vue')
      }
    },
    {
      path: "cities/create",
      name: "citiesCreate",
      component: function () {
        return import( '@/accounting/cities/form.vue')
      }
    },
    {
      path: "cities/:id/edit",
      name: "citiesEdit",
      component: function () {
        return import( '@/accounting/cities/form.vue')
      }
    },

   //pickupLocations routes
    {
      path: "pickupLocations",
      name: "pickupLocations",
      component: function () {
        return import( '@/accounting/pickupLocations/index.vue')
      }
    },
    {
      path: "pickupLocations/create",
      name: "pickupLocationsCreate",
      component: function () {
        return import( '@/accounting/pickupLocations/form.vue')
      }
    },
    {
      path: "pickupLocations/:id/edit",
      name: "pickupLocationsEdit",
      component: function () {
        return import( '@/accounting/pickupLocations/form.vue')
      }
    },
    {
      path: "pickupLocations/:id",
      name: "pickupLocationsShow",
      component: function () {
        return import( '@/accounting/pickupLocations/show.vue')
      }
    },

    //shippingOperations routes 
    {
      path: "shippingOperations",
      name: "shippingOperations",
      component: function () {
        return import( '@/accounting/shippingOperations/index.vue')
      }
    },
    {
      path: "shippingOperations/create",
      name: "shippingOperationsCreate",
      component: function () {
        return import( '@/accounting/shippingOperations/form.vue')
      }
    },
    {
      path: "shippingOperations/:id/edit",
      name: "shippingOperationsEdit",
      component: function () {
        return import( '@/accounting/shippingOperations/form.vue')
      }
    },

    //shippingAddresses
    {
      path: "shippingAddresses",
      name: "shippingAddresses",
      component: function () {
        return import( '@/accounting/shippingAddresses/index.vue')
      }
    },
    {
      path: "shippingAddresses/create",
      name: "shippingAddressesCreate",
      component: function () {
        return import( '@/accounting/shippingAddresses/form.vue')
      }
    },
    {
      path: "shippingAddresses/:id/edit",
      name: "shippingAddressesEdit",
      component: function () {
        return import( '@/accounting/shippingAddresses/form.vue')
      }
    },
    {
      path: "shippingAddresses/:id",
      name: "shippingAddressesShow",
      component: function () {
        return import( '@/accounting/shippingAddresses/show.vue')
      }
    },
];

export default routes;
